import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 14,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'is_contact_blocked', type: 'boolean' }]
    })
  ]
}
